import { post } from './api.service'

const ChatGptService = {
	chatGpt(params: any) {
		return post('/chat-gpt', params, { raw: true })
	},
}

export default ChatGptService
